
/* ---- Desktop price presets ---- */
document.addEventListener('click', function (e) {
    var preset = e.target.closest('.facets__display .desk-preset, .facets__display-vertical .desk-preset');
    if (!preset) return;
    var minVal = parseInt(preset.dataset.min, 10);
    var maxVal = parseInt(preset.dataset.max, 10);
    var container = preset.closest('.facets__display, .facets__display-vertical');
    if (!container) return;
    container.querySelectorAll('.desk-preset').forEach(function (p) {
        p.classList.toggle('desk-preset--on', p === preset);
    });
    var tMin = container.querySelector('input[id$="-GTE"]');
    var tMax = container.querySelector('input[id$="-LTE"]');
    if (!tMin || !tMax) return;
    tMin.value = String(minVal);
    tMax.value = String(maxVal);
    tMin.dispatchEvent(new Event('change', { bubbles: true }));
});

(function () {
    // KFB — Kymee Filter Bar (mobile only)
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var wrap = document.getElementById('kfbWrap');
    if (!wrap) return;

    var pendingKfbSort = null;

    // Enable filter form for collectParams on mobile
    //   var kfbFF = document.getElementById('kfbFF');
    //   if (kfbFF) kfbFF.removeAttribute('data-kfp-skip'); 

    var currentPane = null;

    /* ---- hide the fixed bar once the product grid scrolls out of view ----
       #ProductGridContainer keeps growing with infinite scroll, but it's
       still the same node, so one observer call covers all loaded pages. */
    (function watchGridVisibility() {
        var grid = document.getElementById('ProductGridContainer');
        var wrapper = document.querySelector('.facets-wrapper');
        if (!grid || !wrapper || !('IntersectionObserver' in window)) return;

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                wrapper.classList.toggle('facets-wrapper--grid-hidden', !entry.isIntersecting);
            });
        }, { threshold: 0 });

        io.observe(grid);
    })();

    /* ---- sync preset active state from URL ---- */
    function syncPresets() {
        var sp = new URLSearchParams(window.location.search);
        var urlMin = parseInt(sp.get('filter.v.price.gte') || '0', 10);
        var urlMax = parseInt(sp.get('filter.v.price.lte') || '0', 10);
        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            var pMin = parseInt(p.dataset.min, 10);
            var pMax = parseInt(p.dataset.max, 10);
            p.classList.toggle('kfb-on', urlMax > 0 && pMin === urlMin && pMax === urlMax);
        });
    }

    /* ---- open a pane ---- */
    function openPane(paneId) {
        currentPane = paneId;

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.classList.add('mobile-filter-overlay');

        wrap.classList.remove('kfb-sort-mode');
        wrap.setAttribute('aria-hidden', 'false');
        wrap.classList.add('is-open');

        requestAnimationFrame(function () {
            document.querySelectorAll('#kfbWrap .kfb-pane').forEach(function (p) {
                p.classList.add('kfb-pane--active');
            });

            // Do this after open so opening does not feel stuck.
            setTimeout(function () {
                syncPresets();
            }, 0);
        });
    }

    /* ---- close button ---- */
    var closeBtn = document.getElementById('kfbClose');
    if (closeBtn) closeBtn.addEventListener('click', closeBar);

    /* ---- clear button (AJAX — no page refresh) ---- */
    var clearBtn = document.getElementById('kfbClear');

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            pendingKfbSort = null;

            var resultsUrl = wrap.dataset.resultsUrl || '';
            var baseParams = resultsUrl.includes('?') ? resultsUrl.split('?')[1] : '';
            var ff = document.querySelector('facet-filters-form');

            if (ff && ff.onActiveFilterClick) {
                ff.onActiveFilterClick(baseParams);
            } else {
                window.location.href = resultsUrl || location.pathname;
            }

            closeBar();
        });
    }

    /* ---- active filter pill row (kfbsorting-with-active-filter) ----
       The two "Best Selling" / "Price, low to high" pills are fixed quick-sort
       shortcuts rendered once by facets.liquid (kfb-quick-sort) — this only
       keeps their active state in sync and appends/removes the DYNAMIC pills
       after them: one per checked chip, an active price range, and a
       Clear All pill (always last) when any non-sort filter is active. */
    function pillLi(text, extraClass) {
        var li = document.createElement('li');
        li.className = 'kfbsorting-with-active-filter-item kfb-dynamic-pill' + (extraClass ? ' ' + extraClass : '');
        li.textContent = text;
        return li;
    }

    function applySort(value) {
        document.querySelectorAll('#kfbPaneSort .kfb-sort-opt').forEach(function (o) {
            o.classList.toggle('kfb-on', o.dataset.value === value);
        });
        var select = document.querySelector('select[name="sort_by"]');
        if (select) select.value = value;

        var sp = new URLSearchParams(window.location.search);
        sp.set('sort_by', value);
        sp.delete('page');
        var params = sp.toString();

        if (window.KYMEE_FACETS && typeof window.KYMEE_FACETS.render === 'function') {
            window.KYMEE_FACETS.render(params, { updateHistory: true, force: true });
        } else {
            var ff = document.querySelector('#FacetFiltersForm') &&
                document.querySelector('#FacetFiltersForm').closest('facet-filters-form');
            if (ff && typeof ff.onActiveFilterClick === 'function') {
                ff.onActiveFilterClick(params, { force: true });
            } else {
                window.location.href = location.pathname + (params ? '?' + params : '');
            }
        }
    }

    // final DOM order: active sort first, then active filters, then the
    // unused quick-sort pill(s), then Clear All — anything "applied" leads
    function reorderPills() {
        var list = document.querySelector('.kfbsorting-with-active-filter-list');
        if (!list) return;

        var quickSortPills = Array.prototype.slice.call(list.querySelectorAll('.kfb-quick-sort'));
        var activeQuickSort = quickSortPills.filter(function (p) { return p.classList.contains('kfb-on'); })[0];
        var dynamicSortPill = list.querySelector('.kfb-sort-pill');
        var chipPills = Array.prototype.slice.call(list.querySelectorAll('.kfb-chip-pill'));
        var pricePill = list.querySelector('.kfb-price-pill');
        var clearPill = list.querySelector('.kfbsorting-clear-all');

        var order = [];
        if (activeQuickSort) order.push(activeQuickSort);
        else if (dynamicSortPill) order.push(dynamicSortPill);

        chipPills.forEach(function (p) { order.push(p); });
        if (pricePill) order.push(pricePill);

        quickSortPills.forEach(function (p) {
            if (p !== activeQuickSort) order.push(p);
        });

        if (clearPill) order.push(clearPill);

        order.forEach(function (li) { list.appendChild(li); });
    }

    /* ---- quick-sort pill click — applies immediately, no panel/Apply needed ---- */
    document.addEventListener('click', function (e) {
        var pill = e.target.closest('.kfbsorting-with-active-filter-item.kfb-quick-sort');
        if (!pill) return;
        var value = pill.dataset.value;
        if (!value) return;

        document.querySelectorAll('.kfb-quick-sort').forEach(function (p) {
            p.classList.toggle('kfb-on', p === pill);
        });
        reorderPills();
        applySort(value);
    });

    function renderActiveFilterPills() {
        var list = document.querySelector('.kfbsorting-with-active-filter-list');
        if (!list) return;

        var sp = new URLSearchParams(window.location.search);
        var curSort = sp.get('sort_by');
        var defaultSort = wrap.dataset.defaultSort;
        var activeSort = curSort !== null ? curSort : defaultSort;

        // keep the two fixed quick-sort pills highlighted correctly
        document.querySelectorAll('.kfb-quick-sort').forEach(function (p) {
            p.classList.toggle('kfb-on', activeSort !== null && p.dataset.value === activeSort);
        });

        // drop the previous dynamic pills, rebuild from current state
        list.querySelectorAll('.kfb-dynamic-pill').forEach(function (li) { li.remove(); });

        var hasFilterPill = false;

        // Sort — only when active and NOT one of the two fixed quick-sort
        // pills above (those already show it via their own highlighting)
        var isQuickSort = !!document.querySelector('.kfb-quick-sort[data-value="' + CSS.escape(activeSort || '') + '"]');
        if (activeSort && activeSort !== defaultSort && !isQuickSort) {
            var sortOpt = document.querySelector(
                '#kfbPaneSort .kfb-sort-opt[data-value="' + CSS.escape(activeSort) + '"]'
            );
            if (sortOpt) list.appendChild(pillLi(sortOpt.textContent.trim(), 'kfb-on kfb-sort-pill'));
        }

        // Chip filters (boolean/list) — one pill per checked value
        document.querySelectorAll('#kfbPanelForm .kfb-chip-input:checked').forEach(function (input) {
            var chip = input.closest('.kfb-chip');
            var label = chip ? chip.textContent.trim() : '';
            if (label) {
                list.appendChild(pillLi(label, 'kfb-on kfb-chip-pill'));
                hasFilterPill = true;
            }
        });

        // Price range — active only when it's narrower than the full range
        var tMin = document.querySelector('#kfbPanelForm input[id$="-GTE"]');
        var tMax = document.querySelector('#kfbPanelForm input[id$="-LTE"]');
        if (tMin && tMax) {
            var minVal = parseInt(tMin.value, 10) || 0;
            var maxVal = parseInt(tMax.value, 10) || 0;
            var rangeMin = parseInt(tMin.dataset.min, 10) || 0;
            var rangeMax = parseInt(tMax.dataset.max, 10) || 0;
            if (maxVal > 0 && (minVal > rangeMin || maxVal < rangeMax)) {
                var symbolEl = document.querySelector('#kfbPanelForm .field-currency');
                var symbol = symbolEl ? symbolEl.textContent.trim() : '';
                list.appendChild(pillLi(symbol + minVal + ' - ' + symbol + maxVal, 'kfb-on kfb-price-pill'));
                hasFilterPill = true;
            }
        }

        // Clear All — always last, only when a non-sort filter is active
        if (hasFilterPill) {
            var clearLi = pillLi('Clear All', 'kfbsorting-clear-all');
            clearLi.addEventListener('click', function () {
                if (clearBtn) clearBtn.click();
            });
            list.appendChild(clearLi);
        }

        reorderPills();
    }

    renderActiveFilterPills();

    /* ---- close bar ---- */
    function closeBar() {
        wrap.classList.remove('is-open');
        wrap.setAttribute('aria-hidden', 'true');
        currentPane = null;
        document.querySelectorAll('.kfb-pill-btn').forEach(function (b) {
            b.classList.remove('kfb-pill-btn--active');
        });
        setTimeout(function () {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('mobile-filter-overlay');
        }, 360);
    }

    /* ---- pill button clicks ---- */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.kfb-pill-btn');
        if (!btn || !wrap.contains(btn)) return;

        e.preventDefault();
        e.stopPropagation();

        var pane = btn.dataset.pane || 'kfbPaneAll';

        if (wrap.classList.contains('is-open') && currentPane === pane) {
            closeBar();
        } else {
            openPane(pane);
        }
    });

    /* ---- close on click outside kfbWrap ---- */
    document.addEventListener('click', function (e) {
        if (!wrap.classList.contains('is-open')) return;
        if (wrap.contains(e.target)) return;
        closeBar();
    });

    /* ---- price presets (delegated — survives patchHTML) ---- */
    document.addEventListener('click', function (e) {
        var preset = e.target.closest('#kfbPanelForm .kfb-preset');
        if (!preset) return;

        var minVal = parseInt(preset.dataset.min, 10);
        var maxVal = parseInt(preset.dataset.max, 10);

        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            p.classList.toggle('kfb-on', p === preset);
        });

        var scope = document.getElementById('kfbPanelForm');
        if (!scope) return;

        var tMin = scope.querySelector('input[id$="-GTE"]');
        var tMax = scope.querySelector('input[id$="-LTE"]');
        var rMin = scope.querySelector('.price-range-slider__input--min');
        var rMax = scope.querySelector('.price-range-slider__input--max');
        var dMin = scope.querySelector('[data-price-display="min"]');
        var dMax = scope.querySelector('[data-price-display="max"]');
        var track = scope.querySelector('.price-range-slider__track-active');

        if (!tMin || !tMax || !rMin || !rMax || !track) return;

        var cap = parseInt(rMax.max || maxVal, 10) || maxVal;

        tMin.value = String(minVal);
        tMax.value = String(maxVal);
        rMin.value = String(minVal);
        rMax.value = String(maxVal);

        if (dMin) dMin.textContent = String(minVal);
        if (dMax) dMax.textContent = String(maxVal);

        track.style.left = ((minVal / cap) * 100) + '%';
        track.style.right = (100 - ((maxVal / cap) * 100)) + '%';

        // No dispatchEvent here.
        // Apply button will run AJAX.
    });

    /* ---- sort options (delegated) ---- */

    /* ---- sort options: visual only, apply later ---- */
    document.addEventListener('click', function (e) {
        var opt = e.target.closest('#kfbPaneSort .kfb-sort-opt');
        if (!opt) return;

        var value = opt.dataset.value;
        if (!value) return;

        // Only save sort. Do not apply products/grid here.
        pendingKfbSort = value;

        document.querySelectorAll('#kfbPaneSort .kfb-sort-opt').forEach(function (o) {
            o.classList.toggle('kfb-on', o === opt);
        });

        var select = document.querySelector('select[name="sort_by"]');
        if (select) select.value = value;
    });

    /* ---- Apply button ---- */
    /* ---- Apply button: fast + reliable ---- */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('#kfbApply');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if (btn.dataset.loading === '1') return;

        var form = document.getElementById('kfbPanelForm');
        if (!form) return;

        var fd = new URLSearchParams(new FormData(form));

        if (pendingKfbSort) {
            fd.set('sort_by', pendingKfbSort);
        } else {
            var curSort = new URLSearchParams(window.location.search).get('sort_by');
            if (curSort) fd.set('sort_by', curSort);
        }

        fd.delete('page');

        var params = fd.toString();

        btn.dataset.loading = '1';
        btn.classList.add('is-applying');

        // Close instantly for smooth UX.
        closeBar();

        // Best path: use main controller directly.
        if (window.KYMEE_FACETS && typeof window.KYMEE_FACETS.render === 'function') {
            window.KYMEE_FACETS.render(params, {
                updateHistory: true,
                force: true
            });
        } else {
            // Backup path: use desktop controller custom element.
            var ff =
                document.querySelector('#FacetFiltersForm') &&
                document.querySelector('#FacetFiltersForm').closest('facet-filters-form');

            if (ff && typeof ff.onActiveFilterClick === 'function') {
                ff.onActiveFilterClick(params, { force: true });
            } else {
                // Final fallback if JS controller is not ready.
                window.location.href = location.pathname + (params ? '?' + params : '');
            }
        }

        pendingKfbSort = null;
    });

    /* ---- chip toggle visual feedback ---- */
    document.addEventListener('change', function (e) {
        var input = e.target.closest('#kfbPanelForm .kfb-chip-input');
        if (!input) return;
        var label = input.closest('.kfb-chip');
        if (label) label.classList.toggle('kfb-chip--on', input.checked);
    });

    /* ---- sync after AJAX update ---- */
    document.addEventListener('collection:updated', function () {
        // Keep kfbFF enabled so collectParams() picks it up
        //  var kfbFFel = document.getElementById('kfbFF');
        // if (kfbFFel) kfbFFel.removeAttribute('data-kfp-skip');

        // If panel is open, restore all panes to visible
        if (wrap.classList.contains('is-open')) {
            document.querySelectorAll('.kfb-pane').forEach(function (p) {
                p.classList.add('kfb-pane--active');
            });
        }

        // Sync sort checkmarks — fall back to collection default when sort_by absent from URL
        var curSort = new URLSearchParams(window.location.search).get('sort_by');
        var kfbWrap = document.getElementById('kfbWrap');
        var defaultSort = kfbWrap ? kfbWrap.dataset.defaultSort : null;
        var activeSort = curSort !== null ? curSort : defaultSort;
        document.querySelectorAll('.kfb-sort-opt').forEach(function (o) {
            o.classList.toggle('kfb-on', activeSort !== null && o.dataset.value === activeSort);
        });

        var applyBtn = document.getElementById('kfbApply');
        if (applyBtn) {
            applyBtn.dataset.loading = '0';
            applyBtn.disabled = false;
            applyBtn.classList.remove('is-applying');
        }

        // Sync price presets from URL
        syncPresets();

        // Rebuild the active sort/filter pill row for the new state
        renderActiveFilterPills();

        // scroll all the way to the top whenever a filter/sort is applied
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* ---- slider move → immediately clear preset active state (capture: fires before stopPropagation) ---- */
    document.addEventListener('input', function (e) {
        if (!e.target.closest('#kfbPanelForm .price-range-slider__input')) return;
        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            p.classList.remove('kfb-on');
        });
    }, true);
})();